// src/components/QuizCreator.jsx
import React from "react";

export function QuizCreator({
  step,
  quizName,
  setQuizName,
  onNext,
  onUpload,
  onFinish,
  error,
}) {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100 p-4">
      <div className="bg-white shadow-lg rounded-lg p-8 w-full max-w-md space-y-6">
        {step === 0 ? (
          <>
            <h2 className="text-xl font-bold text-gray-800">
              Step 1: Name Your Quiz
            </h2>

            <input
              type="text"
              placeholder="Quiz Name"
              value={quizName}
              onChange={(e) => setQuizName(e.target.value)}
              className="w-full border border-gray-300 p-2 rounded focus:outline-none focus:ring-2 focus:ring-indigo-400"
            />

            {error && <p className="text-red-600">{error}</p>}

            <button
              onClick={onNext}
              disabled={!quizName.trim()}
              className="w-full bg-indigo-600 text-white py-2 rounded hover:bg-indigo-700 transition disabled:opacity-50"
            >
              Next
            </button>
          </>
        ) : (
          <>
            <h2 className="text-xl font-bold text-gray-800">
              Step 2: Upload Your Quiz File
            </h2>

            <input
              type="file"
              accept=".xlsx,.xls"
              onChange={onUpload}
              className="w-full border border-gray-300 p-2 rounded"
            />

            <button
              onClick={onFinish}
              className="w-full bg-green-600 text-white py-2 rounded hover:bg-green-700 transition"
            >
              Finish
            </button>
          </>
        )}
      </div>
    </div>
  );
}
